import { useEffect, useMemo, useState } from "react";
import { api } from "../api";
import type { SettlementWorkerOption } from "../types";

/** 정산 등록 창에서만 비활성 작업자를 조회한다. 공통 운영 목록은 변경하지 않는다. */
export function useSettlementWorkers(fallback: SettlementWorkerOption[]) {
  const [options, setOptions] = useState<SettlementWorkerOption[] | null>(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true;
    setError("");
    void api.settlementWorkerOptions().then(result => {
      if (current) setOptions(result);
    }).catch(reason => {
      if (current) setError(reason instanceof Error ? reason.message : "정산 작업자 목록을 불러오지 못했습니다.");
    });
    return () => { current = false; };
  }, [attempt]);
  const people = useMemo(() => [...(options ?? fallback)].filter(worker => worker.kind === "human")
    .sort((a, b) => a.displayedName.localeCompare(b.displayedName, "ko-KR") || a.id.localeCompare(b.id)), [options, fallback]);
  return { people, error, retry: () => setAttempt(value => value + 1) };
}

export const settlementWorkerLabel = (worker: SettlementWorkerOption) =>
  `${worker.displayedName}${worker.active ? "" : " (비활성)"}`;
